import { useEffect, useRef, useState, RefObject } from 'react';

type Options = {
  threshold?: number;
  topReveal?: number;
  initialVisible?: boolean;
  scrollRef?: RefObject<HTMLElement>;
};
export function useScrollDirectionVisibility({
  threshold = 6,
  topReveal = 10,
  initialVisible = true,
  scrollRef,
}: Options = {}) {
  const [visible, setVisible] = useState(initialVisible);

  const lastYRef = useRef(0);
  const accRef = useRef(0);

  useEffect(() => {
    const el = scrollRef?.current;

    if (!el) return;

    lastYRef.current = el.scrollTop;

    const onScroll = () => {
      const y = el.scrollTop;
      const dy = y - lastYRef.current;
      lastYRef.current = y;

      if (y <= topReveal) {
        accRef.current = 0;
        setVisible(true);
        return;
      }

      if (Math.abs(dy) < 1) return;

      accRef.current += dy;

      if ((dy > 0 && accRef.current < 0) || (dy < 0 && accRef.current > 0)) {
        accRef.current = dy;
      }

      if (accRef.current > threshold) {
        setVisible(false);
      } else if (accRef.current < -threshold) {
        setVisible(true);
      }
    };

    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [threshold, topReveal, scrollRef?.current]);

  return visible;
}
